module.exports = __webpack_public_path__ + "img/Poland.82020e13.gif";